export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

/* These cart location indices are served as query parameters that say where a user came from.
// These values are stored as strings in a column on the cart
// but shown as numerals in query parameters.
// Example usage:
// /c/sittings?from=1
// A user visiting this url will generate a cart with a creation location of qr_code
*/
export const CART_CREATION_LOCATIONS = {
  home_page: 0,
  qr_code: 1,
};

export const IMAGE_ORIENTATION_CACHE = {};
